<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    labels: {
        type: Array,
        default: () => []
    },
    options: {
        type: Array,
        default: () => []
    },
    title: {
        type: String,
        default: ""
    }
  },
  watch:  {
      labels (val){
        this.chartData.labels = val
      },
      options (val){
        this.chartData.datasets[0].data = val;
        this.chartData.datasets[0].label = this.title;
      },
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: [
          {
            label: this.title,
            backgroundColor: ['#1a2679', '#1ac983', '#fac71e', '#1a75d6', '#fc573b'],
            data: this.options,
            borderWidth: 2,
          }
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
          legend: {
            display: false,
          },
        },
      }
    }
  }
}
</script>

